import React, { useState, useEffect } from 'react';
import TBUploadFlyer from './TBUploadFlyer';
import mixpanel from 'mixpanel-browser';
mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

export default function TBTournamentStep5Flyer(props) {
    const { authState, match, tournament } = props;
    let url;
    if (match.params.slug) {
        url = `/tournament-builder/${match.params.slug}/edit`;
    } else {
        url = `/tournament-builder/new/edit`;
    }

    return (
        <div
            style={{
                padding: 20,
            }}
        >
            <TBUploadFlyer
                {...props}
                tournament={tournament}
                goBack={() => {
                    props.history.push(`${url}/preview`);
                    // setCurrentStep(3);
                }}
                onContinue={() => {
                    props.history.push(`${url}/review`);
                    const user = authState && authState.user && authState.user;
                    mixpanel.track('Tournament flyer uploaded', {
                        ...user,
                        displayName: user.displayName,
                        tournamentId: tournament.id,
                        tournamentName: tournament.name,
                        source: 'web',
                    });
                    // setCurrentStep(5);
                }}
            />
        </div>
    );
}
